/* Consent → pixels.
 *
 * The three pixels in snippets/wf-analytics.liquid start held: Google with
 * `consent default denied`, Meta with `fbq('consent','revoke')`, TikTok with
 * `ttq.holdConsent()`. Something has to release them once the visitor decides.
 *
 * Two halves, and both matter:
 *
 *   1. The banner. Webflow's markup (`fs-cc` attributes) is ours again, but
 *      Finsweet's script never came across, so the buttons are wired here.
 *      They write the decision through Shopify's Customer Privacy API, so it
 *      lands where Shopify's own tracking and any app can see it.
 *
 *   2. The pixels. Released from the API's current state on load and from the
 *      `visitorConsentCollected` event — which fires for our banner, for the
 *      footer's "cookies" button, and for anything else that sets consent.
 *      Keeping this separate from the banner means the pixels still behave
 *      correctly on pages where no banner is shown.
 *
 * Where consent isn't legally required the API reports processing as allowed,
 * so the pixels release by themselves. If the API never loads, nothing is
 * released — held is the safe direction to fail.
 */
(function () {
  var BANNER_DELAY = 5000; /* let the intro animation finish before intruding */
  var STORE = 'anysniff:consent';
  var banner = document.querySelector('[fs-cc="banner"]');
  var applied = null;

  /* ---- pixels ---------------------------------------------------------- */

  function apply(analytics, marketing, preferences) {
    var key = [analytics, marketing, preferences].join('|');
    if (key === applied) return; /* don't spam the pixels on every event */
    applied = key;

    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: analytics ? 'granted' : 'denied',
        ad_storage: marketing ? 'granted' : 'denied',
        ad_user_data: marketing ? 'granted' : 'denied',
        ad_personalization: marketing ? 'granted' : 'denied',
        functionality_storage: preferences ? 'granted' : 'denied',
        personalization_storage: preferences ? 'granted' : 'denied'
      });
    }
    /* Meta and TikTok have no analytics/marketing split — both are ad pixels. */
    if (typeof window.fbq === 'function') {
      window.fbq('consent', marketing ? 'grant' : 'revoke');
    }
    if (window.ttq && typeof window.ttq.grantConsent === 'function') {
      if (marketing) { window.ttq.grantConsent(); } else { window.ttq.revokeConsent(); }
    }
  }

  function api() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function readCurrent() {
    var cp = api();
    if (!cp) return;
    try {
      apply(cp.analyticsProcessingAllowed(), cp.marketingAllowed(), cp.preferencesProcessingAllowed());
    } catch (e) { /* leave the pixels held */ }
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    var d = (event && event.detail) || {};
    apply(!!d.analyticsAllowed, !!d.marketingAllowed, !!d.preferencesAllowed);
    hide();
  });

  /* ---- banner ---------------------------------------------------------- */

  /* The stylesheet keeps .cookie_banner at display:none and its layout is a
     flex row, so "flex" — not "". */
  function show() { if (banner) banner.style.display = 'flex'; }
  function hide() { if (banner) banner.style.display = 'none'; }

  function remember(v) { try { localStorage.setItem(STORE, v); } catch (e) {} }
  function remembered() { try { return localStorage.getItem(STORE); } catch (e) { return null; } }

  function record(granted) {
    remember(granted ? 'granted' : 'denied');
    apply(granted, granted, granted);
    var cp = api();
    if (cp && typeof cp.setTrackingConsent === 'function') {
      cp.setTrackingConsent(
        { analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted },
        function () { /* Shopify persists it */ }
      );
    }
    hide();
  }

  if (banner) {
    hide(); /* never flash before we know whether a decision already exists */
    var allow = banner.querySelector('[fs-cc="allow"]');
    var deny = banner.querySelector('[fs-cc="deny"]');
    if (allow) allow.addEventListener('click', function (e) { e.preventDefault(); record(true); });
    if (deny) deny.addEventListener('click', function (e) { e.preventDefault(); record(false); });
  }

  function maybeShowBanner() {
    if (!banner) return;
    var cp = api();
    if (cp && typeof cp.shouldShowBanner === 'function') {
      try { if (!cp.shouldShowBanner()) return; } catch (e) { /* fall through */ }
    } else if (remembered() !== null) {
      return;
    }
    setTimeout(show, BANNER_DELAY);
  }

  /* ---- Lenis a panel preferencji ---------------------------------------
   * Strona przewija sie przez Lenis, ktory przechwytuje kolko myszy na calym
   * dokumencie. Panel Shopify ma wlasny obszar przewijania, wiec bez zaczepu
   * nie da sie go przewinac — kolko trafialo w Lenis i ruszalo strone pod
   * spodem. Stara strona miala taki zaczep dla CookieYes; przy porcie wypadl.
   *
   * Dwa dzialania naraz, bo rozwiazuja dwie rozne rzeczy:
   *   data-lenis-prevent  Lenis oddaje kolko obszarowi tresci panelu
   *   lenis.stop()        strona pod spodem stoi, dopoki panel jest otwarty
   * Tak samo robi szuflada koszyka w anysniff-cart.js.
   */

  function bindLenis() {
    // Korzen panelu tworzy skrypt prywatnosci Shopify, ktory startuje PO nas.
    // Bez ponawiania zaczep wchodzil w pustke i nigdy sie nie wpinal.
    var tries = 0;
    (function attach() {
      var root = document.getElementById('shopify-pc__prefs');
      if (!root) {
        if (++tries > 40) return;          // rezygnacja po ~10 s
        setTimeout(attach, 250);
        return;
      }
      observe(root);
    })();
  }

  function observe(root) {
    var wasOpen = false;

    function sync() {
      // offsetParent jest NULL dla kazdego elementu position: fixed, niezaleznie
      // od tego, czy widac go na ekranie — a panel wlasnie taki jest, wiec test
      // przez offsetParent zawsze dawal „zamkniety". getClientRects() zwraca
      // pusta liste tylko wtedy, gdy element naprawde nie jest renderowany.
      var dialog = document.getElementById('shopify-pc__prefs__dialog');
      var open = !!(dialog && dialog.getClientRects().length > 0);
      if (open === wasOpen) return;
      wasOpen = open;

      if (open) {
        var scroller = dialog.querySelector('[class*="scrollable"]');
        if (scroller) scroller.setAttribute('data-lenis-prevent', '');
        if (window.lenis) window.lenis.stop();
      } else if (window.lenis) {
        window.lenis.start();
      }
    }

    new MutationObserver(sync).observe(root, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'open', 'aria-hidden']
    });
    sync();
  }

  /* ---- boot ------------------------------------------------------------ */

  function boot() {
    readCurrent();
    maybeShowBanner();
    bindLenis();
  }

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) { if (error) { maybeShowBanner(); bindLenis(); } else { boot(); } }
    );
  } else {
    boot();
  }
})();
